class StoriesSlider extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
    this.dots = [];
  }

  connectedCallback() {
    this.initEmbla();
  }

  initEmbla() {
    const emblaNode = this.querySelector('.embla');
    const options = { loop: false, alignItems: 'center' };

    if (emblaNode) {
      this.embla = EmblaCarousel(emblaNode, options);
      this.setupDots();
      this.embla.on('select', this.updateDots.bind(this));
    }
  }

  setupDots() {
    this.dots = Array.from(this.querySelectorAll('.slider-dots button'));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.embla.scrollTo(index);
      });
    });
  }

  updateDots() {
    const selectedIndex = this.embla.selectedScrollSnap();
    this.dots.forEach((dot, index) => {
      if (index === selectedIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
}

customElements.define('stories-slider', StoriesSlider);
